import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const getDaySuffix = (day: number): string => {
  if (day >= 11 && day <= 13) return 'th';

  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatTime = (time: string) => {
  const timeMatches = time.match(/^([01]\d|2[0-3])(:[0-5]\d)(:[0-5]\d)?$/);

  if (timeMatches) {
    const hours = +timeMatches[1];
    const period = hours < 12 ? ' AM' : ' PM';
    return `${hours % 12 || 12}${timeMatches[2]}${timeMatches[3] || ''}${period}`;
  }

  return time;
};

export const formatDate = (
  date: string,
  format: string,
  config?: {
    dateFormat: string;
  }
) => {
  return dayjs(date, config?.dateFormat).format(format);
};
